<footer class="footer">
  <div class="footer-shell">
    <div class="footer-logo-row">
      <img class="footer-logo" src="images/webps/orderyaa-white.png" alt="orderYaa ERP" />
    </div>

    <div class="footer-grid">
      <div class="footer-column">
        <h3>Services</h3>
        <ul>
          <li *ngFor="let item of services">
            <a *ngIf="item.route" [routerLink]="item.route">{{ item.label }}</a>
            <a *ngIf="!item.route" href="#" (click)="$event.preventDefault()">{{ item.label }}</a>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h3>Core modules</h3>
        <ul>
          <li *ngFor="let item of coreModules">
            <a *ngIf="item.route" [routerLink]="item.route">{{ item.label }}</a>
            <a *ngIf="!item.route" href="#" (click)="$event.preventDefault()">{{ item.label }}</a>
          </li>
        </ul>
      </div>

      <div class="footer-column">
        <h3>About us</h3>
        <ul>
          <li *ngFor="let item of aboutLinks">
            <a *ngIf="item.route" [routerLink]="item.route">{{ item.label }}</a>
            <a *ngIf="!item.route" href="#" (click)="$event.preventDefault()">{{ item.label }}</a>
          </li>
        </ul>
      </div>

      <div class="footer-column footer-copy-block">
        <p class="footer-copy-text">
          OrderYaa ERP combines powerful business tools into one intelligent platform designed to simplify operations,
          improve productivity, and support business growth.
        </p>

        <p class="footer-copy-text footer-copy-text-strong">
          Built for simplicity, speed, and seamless business management.
        </p>

        <a class="footer-contact-email" href="mailto:hr@techcolleagues.com">
          <i class="fas fa-envelope"></i> hr&#64;techcolleagues.com
        </a>

        <div class="footer-social-row">
          <a *ngFor="let link of socialLinks" [href]="link.url" target="_blank" rel="noopener noreferrer" [attr.aria-label]="link.name">
            <i class="{{ link.icon }}"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bottom-line"></div>

    <div class="footer-bottom-copy">&copy; 2026 . orderYaa ERP</div>
  </div>
</footer>
